import { render } from "./TableOfContentsEntry.vue?vue&type=template&id=79e67860&ts=true"
import script from "./TableOfContentsEntry.vue?vue&type=script&lang=ts"
export * from "./TableOfContentsEntry.vue?vue&type=script&lang=ts"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__